/**
 * @generated SignedSource<<88c7c6e3ea2a5f724091871538a1bf71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CasesItem_item$data = {
  readonly id: string;
  readonly namusId: string | null;
  readonly othramCaseNumber: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "CasesItem_item";
};
export type CasesItem_item$key = {
  readonly " $data"?: CasesItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CasesItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CasesItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "namusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "othramCaseNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Case",
  "abstractKey": null
};

(node as any).hash = "9ad98612bdbcccdef6138b2ba7cf7122";

export default node;
